import { Avatar, Typography } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import React from 'react'
import { useSelector } from 'react-redux'
import { userSelector } from 'app-redux/selectors'
import styles from './style.module.scss'

const OutletSelectorHeader = ({ message }) => {
  const user = useSelector(userSelector)

  return (
    <div className={styles.header}>
      <div className={styles.headerLeft}>
        <Avatar
          src={user?.profile_image}
          alt={user?.name}
          icon={<UserOutlined />}
          size={64}
          className={styles.headerAvatar}
        />
        <div className={styles.headerText}>
          <Typography.Title level={4} className={styles.greeting}>
            Halo, {user?.name || 'User'}!
          </Typography.Title>
          <p className={styles.instruction}>{message}</p>
        </div>
      </div>
      <div className={styles.headerRight}>
        <span className={styles.time}>{dayjs().format('HH:mm')}</span>
        <span className={styles.date}>{dayjs().format('DD/MM/YYYY')}</span>
      </div>
    </div>
  )
}

export default OutletSelectorHeader
